var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('colored-letter-square',{attrs:{"name":_vm.data.name,"length":2,"color":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }